import {h, Fragment} from "preact"
export default StarIcon = ({ filled, partial = false }) => (
    <svg 
        viewBox="0 0 18 18" 
        xmlns="http://www.w3.org/2000/svg" 
        width="15" 
        height="15"
    >
        <defs>
            <linearGradient id={`yotpo_stars_gradient_${Math.random()}`}>
                <stop offset={partial ? "50%" : "100%"} stop-color="#F0CF69"></stop>
                <stop stop-opacity="1" offset={partial ? "50%" : "100%"} stop-color="#FFFFFF"></stop>
            </linearGradient>
        </defs>
        <path 
            aria-hidden="true"
            style="pointer-events: none;"
            d="M9 14.118L14.562 17.475L13.086 11.148L18 6.891L11.529 6.342L9 0.375L6.471 6.342L0 6.891L4.914 11.148L3.438 17.475L9 14.118Z" 
            stroke="#F0CF69" 
            fill={filled ? "#F0CF69" : partial ? "url('#yotpo_stars_gradient_" + Math.random() + "')" : "transparent"}
        />
    </svg>
);
